export const BLACK_FRIDAY_END_DATE = "2021-12-01T00:00:00.000";

const getSuperEnemEndDate = () => {
	const endDate = new Date("2022-02-16T21:00:00.000");
	const today = new Date();

	if (today > endDate) {
		endDate.setDate(today.getDate() + 7);
	}

	return String(endDate);
};

export const SUPER_ENEM_END_DATE = getSuperEnemEndDate();

export const VEM_DE_SEMI_END_DATE = "2022-03-14T00:00:00.000";

export const ULTIMA_CHAMADA_END_DATE = "2022-04-03T00:00:00.000";

export const MEGA_MAIO_END_DATE = "2022-05-31T23:59:00.000";

export const KROTON_INIT_DATE = "2022-06-08T00:00:00.000";
export const KROTON_END_DATE = "2022-06-17T23:59:00.000";

export const ARRAIA_INIT_DATE = "2022-06-20T00:00:00.000";
export const ARRAIA_END_DATE = "2022-07-07T23:59:00.000";

export const ESTACIO_INIT_DATE = "2022-07-11T00:00:00.000";
export const ESTACIO_END_DATE = "2022-07-15T23:59:00.000";
